import React from "react"

export default function CrawlingStep({ t, shop, profile }) {
  const current = profile?.crawl_progress_current ?? 0
  const total = profile?.crawl_progress_total ?? 0
  const hasTotal = total > 0
  const percent = hasTotal ? Math.min(100, Math.round((current / total) * 100)) : 0

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <span aria-hidden className="inline-block w-2 h-2 rounded-full bg-ai animate-pulse" />
        <h1 className="text-[28px] font-medium tracking-[-0.035em] text-ink-primary">
          {t("dashboard.onboarding.crawling.title")}
        </h1>
      </div>

      <p className="text-sm text-ink-secondary leading-relaxed">
        {t("dashboard.onboarding.crawling.lede", { url: shop.url })}
      </p>

      <div className="space-y-2">
        <div className="h-1 bg-rule rounded-pill overflow-hidden">
          {hasTotal ? (
            <div
              className="h-full bg-ai transition-[width] duration-500 ease-out"
              style={{ width: `${percent}%` }}
            />
          ) : (
            <div className="h-full bg-ai/40 animate-pulse" style={{ width: "25%" }} />
          )}
        </div>

        <div
          className="flex justify-between font-mono text-[10px] tracking-[0.1em] text-ink-tertiary"
          style={{ fontVariantNumeric: "tabular-nums" }}
        >
          <span>
            {hasTotal
              ? t("dashboard.onboarding.crawling.progress", { current, total })
              : t("dashboard.onboarding.crawling.discovering")}
          </span>
          <span>{hasTotal ? `${percent}%` : ""}</span>
        </div>
      </div>
    </div>
  )
}
